var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Configuration } from './configuration';
import { HaKuBuApi } from './api';
import axios from 'axios';
import Store from '@/store/store.js';
import router from '@/plugins/router.js';
import booking from '@/mixins/booking';
class ApiEndpoints {
    constructor() {
        this.basePath = process.env.VUE_APP_CVPNET_API_BASEURL;
        this.configuration = new Configuration({ basePath: this.basePath });
        this.createConfiguration();
        this.addInterceptors();
    }
    addInterceptors() {
        axios.interceptors.request.use((request) => {
            const token = Store.state.SessionData.member ? Store.state.SessionData.member.authToken : '';
            if (token != null && token.length > 0) {
                request.headers['Authorization'] = `Bearer ${token}`;
            }
            return request;
        }, (error) => {
            if (error.response) {
                if (error.response.status === 401) {
                    console.log('Status 401: Token abgelaufen');
                    //Snackbar.show(snackbars.tokenExpired);
                    booking.reset();
                }
                else {
                    console.log('Status: ' + error.response.status);
                    var requestUrl = error.config.url;
                }
            }
            return Promise.reject(error);
        });
        axios.interceptors.response.use((response) => response, (error) => __awaiter(this, void 0, void 0, function* () {
            if (error.request && error.request) {
                if (error.request.status === 401) {
                    // ?how to get the snackbar component in here?!
                    booking.reset();
                }
                else {
                    var responseUrl = error.config.url;
                    var urlSplit = responseUrl.split('/');
                    // get the index of "api" as the key point
                    var routeApiIndex = urlSplit.indexOf('api');
                    // get the name of the controller
                    var controller = urlSplit[routeApiIndex + 1];
                    var action = '';
                    // identify and break down parameters
                    var urlHasRouteParams = urlSplit.length > 7;
                    var routeParams = [];
                    var queryParams = [];
                    if (urlHasRouteParams) {
                        let tmpQueryParams = undefined;
                        // loop through route params till query params show up
                        for (var i = routeApiIndex + 2; i < urlSplit.length; i++) {
                            if (urlSplit[i].includes('?')) {
                                var querySplit = urlSplit[i].split('?');
                                routeParams.push(querySplit[0]); // push last route param to array
                                tmpQueryParams = querySplit[1];
                            }
                            else {
                                routeParams.push(urlSplit[i]);
                            }
                        }
                        if (tmpQueryParams) {
                            var queryParamSplit = tmpQueryParams.split('&');
                            queryParamSplit.forEach((queryParam) => {
                                // create key-value-pairs
                                var paramSplit = queryParam.split('=');
                                queryParams.push({ key: paramSplit[0], value: paramSplit[1] });
                            });
                        }
                        // in the case of route parameters we dont have an direct action
                        action = '---';
                    }
                    else {
                        var lastSectionSplit = urlSplit[routeApiIndex + 2].split('?');
                        action = lastSectionSplit[0];
                        if (lastSectionSplit.includes('&')) {
                            var queryParamSplit = lastSectionSplit[1].split('&');
                            queryParamSplit.forEach((queryParam) => {
                                var paramSplit = queryParam.split('=');
                                // create key-value-pairs
                                queryParams.push({ key: paramSplit[0], value: paramSplit[1] });
                            });
                        }
                    }
                    // create the error object for the errorview
                    var errorObj = {
                        controller: controller,
                        action: action,
                        fullRoute: error.config.url,
                        routeParameters: routeParams,
                        queryParameters: queryParams,
                        axiosErrorCode: error.code,
                        httpStatus: error.request.status,
                        errorName: error.name,
                        errorMessage: error.message,
                        loginUrl: window.location.origin + '/' + window.location.pathname.split('/')[1],
                    };
                    // redirect to error page and put the errorObj into the query section of the url
                    router.push({
                        path: '/Error',
                        query: {
                            errorObj: JSON.stringify(errorObj),
                        },
                    });
                }
            }
            return Promise.reject(error);
        }));
    }
    createConfiguration() {
        const config = new Configuration({ basePath: this.basePath });
        config.baseOptions = {
            withCredentials: false,
        };
        this.configuration = config;
    }
    get BasePath() {
        return this.configuration.basePath;
    }
    get HaKuBu() {
        return new HaKuBuApi(this.configuration);
    }
}
export const Api = new ApiEndpoints();
